export default __webpack_public_path__ + "static/media/WelcomePageWord.18f58589.svg";